const MEDIA_TYPES = {
    IMAGE: "image",
    VIDEO: "video",
    DOCUMENT: "document",
    BANNER: "banner",
};

export default MEDIA_TYPES;